const isNumeric = (str) => {
    if (typeof str != "string") return false 
    return !isNaN(str) && !isNaN(parseFloat(str))
}

const getClientKey = () => {
    const urlParams = new URLSearchParams(window.location.search)
    let nickname = window.location.pathname.split('/')[3]
    nickname = !isNumeric(nickname) ? nickname : urlParams.get('nickname')  
    return !isNumeric(nickname) ? `${nickname}-storage` : "aNqUIsL88CnvaYU6"
}

export default getClientKey()